import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSearch, setSort } from "../../features/JobSorting/JobSortingSlice";

export default function AvailableJobsHeader() {
  const [searching, setSearching] = useState("");
  const [sorting, setSorting] = useState("");
  const { search, sortBy } = useSelector((state) => state.JobSort);

  const dispatch = useDispatch();

  const setSearchValue = (value) => {
    setSearching(value);
    dispatch(setSearch(value.trim()));
  };

  const setSortValue = (value) => {
    setSorting(value);
    dispatch(setSort(value));
  };

  useEffect(() => {
    setSearching(search);
    setSorting(sortBy);
  }, []);

  return (
    <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
      <h1 className="lws-section-title">All Available Jobs</h1>
      <div className="flex gap-4">
        <div className="search-field group flex-1">
          <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500" />
          <input
            type="text"
            placeholder="Search Job"
            className="search-input"
            onChange={(e) => setSearchValue(e.target.value)}
            value={searching}
            id="lws-searchJob"
          />
        </div>
        <select
          id="lws-sort"
          name="sort"
          autoComplete="sort"
          className="flex-1"
          onChange={(e) => setSortValue(e.target.value)}
          value={sorting}
        >
          <option value="">Default</option>
          <option value="asc">Salary (Low to High)</option>
          <option value="dsc">Salary (High to Low)</option>
        </select>
      </div>
    </div>
  );
}
